<form ngForm name="partnerForm" class="row">
  <div *ngIf="showGender && !easyMode && isFieldAvailable('gender')" class="col-12 col-md-6">
    <app-dropdown [title]="'Gender'" [items]="genders" [name]="'gender'" [(ngModel)]="partner.gender" required></app-dropdown>
  </div>
  <div *ngIf="showPartnerTitle && !easyMode && isFieldAvailable('title')" class="col-12 col-md-6">
    <app-dropdown [title]="'Title'" [items]="partnerTitles" [name]="'partnerTitle'" [ngModel]="partner.title" (ngModelChange)="onChangePartnerTitle($event)" required></app-dropdown>
  </div>
  <div *ngIf="!easyMode && isChild" class="col-12 col-md-6">
    <app-datepicker [title]='"Date Of Birth" | translate' [name]="'dateOfBirth'" [(ngModel)]="partner.dateOfBirthMoment"
      required appValidateAge [minAge]="minAge" [maxDate]="maxDate"></app-datepicker>
  </div>
  <div *ngIf="isShowPartnerFirstLastNames && isFieldAvailable('firstName')" class="col-12 col-md-6">
    <app-input [title]='"First Name" | translate' [name]="'firstName'" [(ngModel)]="partner.firstName" required minLength="2"></app-input>
  </div>
  <div *ngIf="isShowPartnerFirstLastNames && isFieldAvailable('lastName')" class="col-12 col-md-6">
    <app-input [title]='"Last Name" | translate' [name]="'lastName'" [(ngModel)]="partner.lastName" required minLength="2"></app-input>
  </div>
  <div *ngIf="isShowPartnerLastFirstNames && isFieldAvailable('lastName')" class="col-12 col-md-6">
    <app-input [title]='"Last Name" | translate' [name]="'lastName'" [(ngModel)]="partner.lastName" required minLength="2"></app-input>
  </div>
  <div *ngIf="isShowPartnerLastFirstNames && isFieldAvailable('firstName')" class="col-12 col-md-6">
    <app-input [title]='"First Name" | translate' [name]="'firstName'" [(ngModel)]="partner.firstName" required minLength="2"></app-input>
  </div>
  <div *ngIf="showDateOfBirth && !easyMode && isFieldAvailable('dateOfBirth')" class="col-12 col-md-6">
    <app-datepicker [title]='"Date Of Birth" | translate' [name]="'dateOfBirth'" [(ngModel)]="partner.dateOfBirthMoment" required appValidateAge
      [minAge]="minAge" [maxDate]="maxDate"></app-datepicker>
  </div>
  <div *ngIf="showPhone" class="col-12 col-md-6">
    <app-input [title]='"Phone" | translate' reverse="false" [name]="'phone'" [(ngModel)]="partner.phone" minlength="4" maxlength="20" required></app-input>
  </div>
  <div *ngIf="showAddress" class="col-12 col-md-6">
    <app-input [title]='"Address" | translate' [(ngModel)]="partner.street" [name]="'street'" maxlength="100" required></app-input>
  </div>
  <div *ngIf="(showZip && !easyMode && isFieldAvailable('zip')) || showAddress" class="col-12 col-md-6">
    <app-input [title]='"Zip" | translate' [name]="'zip'" [(ngModel)]="partner.zip" required minLength="4" maxLength="6"></app-input>
  </div>
  <div *ngIf="showAddress" class="col-12 col-md-6">
    <app-input [title]='"City" | translate' [name]="'city'" [(ngModel)]="partner.city" required></app-input>
  </div>
  <div *ngIf="showEmail && isFieldAvailable('email')" class="col-12 col-md-6"  [ngClass]="easyMode ? 'col-md-12' : 'col-md-6'" >
    <app-input [readonly]="!showRepeatEmail" [title]='"Email" | translate' appValidateEqual="repeatEmail" reverse="true" [name]="'email'"
      [(ngModel)]="partner.email" minLength="4" email required></app-input>
  </div>
  <div *ngIf="showRepeatEmail && !easyMode && isFieldAvailable('email')" class="col-12 col-md-6">
    <app-input [title]='"Repeat Email" | translate' appValidateEqual="email" reverse="false" [name]="'repeatEmail'" [type]='"text"'
      [(ngModel)]="repeatEmail" minLength="4" email required></app-input>
  </div>
  <ng-container *ngFor="let field of additionalFields">
    <div *ngIf="isCharsField(field) || isDateField(field)" class="col-12 col-md-6">
      <app-input *ngIf="isCharsField(field)" [title]='field.title | translate' [name]="field.name" [(ngModel)]="partner.additionalFields[field.name]" [required]="field.isRequired"></app-input>
      <app-datepicker *ngIf="isDateField(field)" [title]='field.title | translate' [name]="field.name" [(ngModel)]="partner.additionalFields[field.name]" [required]="field.isRequired"></app-datepicker>
    </div>
  </ng-container>
  <ng-container *ngFor="let field of additionalFields">
    <div *ngIf="isBooleanField(field)" class="col-12">
      <app-checkbox [title]='field.description | translate' [name]="field.name" [(ngModel)]="partner.additionalFields[field.name]"></app-checkbox>
    </div>
  </ng-container>
</form>
